import type { StyleLayer } from './utils/types'

export const layers_ziele_plus_publictransport: StyleLayer[] = [
  {
    id: 'publictransport',
    type: 'symbol',
    filter: ['has', 'category'],
    layout: {
      'icon-allow-overlap': true,
      'icon-image': [
        'match',
        ['get', 'category'],
        ['ferry_station'],
        'ferry',
        ['railway_station'],
        'train',
        ['light_rail_station'],
        's-bahn',
        ['tram_station'],
        'tram',
        ['subway_station'],
        'u-bahn',
        '',
      ],
      'icon-padding': 1,
      'icon-size': [
        'interpolate',
        ['linear'],
        ['zoom'],
        8,
        ['match', ['get', 'category'], ['light_rail_station'], 0.6, 0.8],
        11,
        [
          'match',
          ['get', 'category'],
          ['ferry_station'],
          0.8,
          ['light_rail_station'],
          0.6,
          ['subway_station', 'tram_station'],
          0.8,
          1,
        ],
        16,
        [
          'match',
          ['get', 'category'],
          ['ferry_station'],
          0.8,
          ['light_rail_station'],
          1,
          ['subway_station', 'tram_station'],
          0.8,
          1.5,
        ],
      ],
      'text-offset': [5, 0],
      'text-size': 12,
    },
    paint: {
      'icon-opacity': [
        'step',
        ['zoom'],
        ['match', ['get', 'category'], ['railway_station'], 1, 0],
        8,
        ['match', ['get', 'category'], ['railway_station'], 1, 0],
        10,
        ['match', ['get', 'category'], ['railway_station'], 1, 0],
        10.1,
        ['match', ['get', 'category'], ['railway_station', 'light_rail_station'], 1, 0],
        12.9,
        ['match', ['get', 'category'], ['railway_station', 'light_rail_station'], 1, 0],
        13,
        [
          'match',
          ['get', 'category'],
          [
            'railway_station',
            'light_rail_station',
            'tram_station',
            'ferry_station',
            'subway_station',
          ],
          1,
          0,
        ],
      ],
    },
  },
]
